/** Temas de Ant Design: color primario por defecto #4682b4 y constructores de tema claro y oscuro con tokens y componentes Layout, Menu y Drawer. */
import { ThemeConfig, theme } from "antd";

export const DEFAULT_PRIMARY = "#4682b4";

export const getLightTheme = (primary: string): ThemeConfig => ({
  token: {
    colorPrimary: primary,
    colorLink: primary,
    colorSuccess: "#52c41a",
    colorError: "#f5222d",
    colorWarning: "#faad14",
    colorInfo: primary,
    borderRadius: 3,
    fontSize: 15,
    controlHeight: 34,
    fontFamily:
      "'Segoe UI Variable Text', 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  components: {
    Layout: {
      headerBg: "#ffffff",
      bodyBg: "#f0f2f5",
      siderBg: "#3a4042",
    },
    Menu: {
      colorBgContainer: "#3a4042",
      itemHoverBg: "#4a5258",
      itemSelectedBg: primary,
      itemSelectedColor: "#ffffff",
      itemColor: "rgba(255, 255, 255, 0.85)",
    },
    Drawer: {
      paddingLG: 20,
    },
  },
});

export const getDarkTheme = (primary: string): ThemeConfig => ({
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: primary,
    colorLink: primary,
    colorSuccess: "#49aa19",
    colorError: "#dc4446",
    colorWarning: "#d89614",
    colorInfo: primary,
    borderRadius: 3,
    fontSize: 15,
    controlHeight: 34,
    fontFamily:
      "'Segoe UI Variable Text', 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  components: {
    Layout: {
      headerBg: "#1f1f1f",
      bodyBg: "#141414",
      siderBg: "#1a1a1a",
    },
    Menu: {
      colorBgContainer: "#1a1a1a",
      itemHoverBg: "#2a2a2a",
      itemSelectedBg: primary,
      itemSelectedColor: "#ffffff",
    },
    Drawer: {
      paddingLG: 20,
    },
  },
});
